// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// InitialState
import initialState from './initialState'


// Controller
import recommendationsCtrl from 'hfty-ctrl-recommendations'

// Exports
export default createReducer({
  ...initialState,
}, {
  ...recommendationsCtrl.reducers,
})
